import { observer } from 'mobx-react';
import { FormFieldLine } from '../../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../../components/inputs/input/input';
import { IValidationGroup } from '../../../../../../../../hooks/validation-group/validation-group-hook';
import CustomerNumberCredentialsStore from '../../../../../stores/credentials/shipping/customer-number-credentials-store';
import IntersoftCredentialsStore from '../../../../../stores/credentials/shipping/intersoft-credentials-store';
import MondialRelayCredentialsStore from '../../../../../stores/credentials/shipping/mondial-relay-credentials-store';

interface IIntegrationProps {
    credentialsStore: CustomerNumberCredentialsStore | IntersoftCredentialsStore | MondialRelayCredentialsStore,
    validationGroup: IValidationGroup,
    label?: string,
    note?: string,
    disabled?: boolean
}

const CustomerNumberField: React.FC<IIntegrationProps> = observer(({ credentialsStore, validationGroup, label, note, disabled }) => {
    return (
        <FormFieldLine
            required
            label={label || 'Customer Number'}
            key='customer_number'
            note={note || 'Customer number for this account'}
        >
            <Input
                value={credentialsStore.customerNumber}
                onChange={credentialsStore.setCustomerNumber}
                validationGroup={validationGroup}
                type='password'
                autoComplete='new-password'
                required
                disabled={disabled}
            />
        </FormFieldLine>
    );
});

export default CustomerNumberField;
